import getEnumLabel from 'gpcore-apikit/lib/getEnumLabel';
import { BillStatus } from 'gpcore-grpc/gpcore/api/cloud/v1/billing_pb';

export default () => {
  const getNormalizedStatus = (status: BillStatus) => getEnumLabel(BillStatus, status);

  const getStatus = (status: BillStatus) => {
    let componentState = 'none';
    switch (status) {
      case BillStatus.FAILED:
        componentState = 'danger';
        break;

      case BillStatus.SUCCEEDED:
        componentState = 'success';
        break;
      case BillStatus.PENDING:
        componentState = 'warning';
        break;
      default:
        componentState = 'none';
    }

    return {
      state: componentState as 'success' | 'danger' | 'warning' | 'info' | 'none',
      label: getNormalizedStatus(status),
    };
  };

  return { getStatus, getNormalizedStatus };
};
